import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom'; // Added useNavigate for redirection
import './NavBar.css';
import { getStoredData } from '../../api/fetchData.jsx';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faCog, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { useMediaQuery } from 'react-responsive'; // Import for responsive design
import MobileNavBar from './MobileNavBar'; // Import MobileNavBar component

const Navbar = () => {
  const [navData, setNavData] = useState([]);
  const [logo, setLogo] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isUsernamePopupOpen, setIsUsernamePopupOpen] = useState(false);
  const [isIconsPopupOpen, setIsIconsPopupOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const isMobile = useMediaQuery({ maxWidth: 786 });
  const [username, setUsername] = useState('');
  const navigate = useNavigate(); // Added useNavigate hook
  const data = getStoredData();
  const totalData = data[0];

  useEffect(() => {
    try {
      const data = getStoredData();
      const totalData = data[0];
      if (totalData?.page === 'navbar') {
        setNavData(totalData.menu || []);
        setLogo(totalData.logo || '');
      }
    } catch (error) {
      console.error('Error fetching stored data:', error);
    }

    // Retrieve the logged-in user's username from localStorage or JWT token
    const userDetails = JSON.parse(localStorage.getItem('userDetails'));
    if (userDetails) {
      setUsername(userDetails.name || 'Guest'); 
    }
  }, []);

  const logout = () => {
    console.log('Logging out...');
  
    // Clear all local/session storage
    localStorage.removeItem('authenticated');
    localStorage.removeItem('token');
    localStorage.removeItem('userDetails');
    localStorage.removeItem('expirationTime');
    sessionStorage.clear();
  
    setUsername('');
  
    // Redirect to login
    navigate('/login');
  
    // Optional: refresh after short delay to clear all context/UI if needed
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };
  

  

  // Function to navigate to profile page
  const goToProfile = () => {
    navigate('/profile'); // Redirect to the profile page
  };

  const toggleDropdown = (index) => {
    setDropdownOpen(dropdownOpen === index ? null : index);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  const toggleUsernamePopup = () => {
    setIsUsernamePopupOpen((prev) => !prev);
    setIsIconsPopupOpen(false); // Close the icons popup
  };

  const toggleIconsPopup = async () => {
    if (!isIconsPopupOpen && notifications.length === 0) {
      try {
        const response = await axios.get('http://localhost:5000/notification');
        setNotifications(response.data.slice(0, 5));
      } catch (error) {
        console.error('Error fetching notifications:', error);
      }
    }
    setIsIconsPopupOpen((prev) => !prev);
    setIsUsernamePopupOpen(false);
  };

  return (
    <>
      {isMobile ? (
        <MobileNavBar navData={navData} logo={logo} />
      ) : (
        <>

          {/* Sidebar Navigation */}
          <div
            className={`sidebar ${isSidebarOpen ? "expanded" : "collapsed"}`}
          >
            {/* Logo */}
            {logo && <img src={totalData.CompanyLogo} alt="Logo" className="navbar-logo" />}

            {/* Sidebar Items */}
            <ul>
              {navData.map((item, index) => (
                <li key={index}>
                  <div
                    className="menu-item"
                    onClick={() => item.submenu && toggleDropdown(index)}
                  >
                    <Link to={item.link}>
                      <span
                        className={`menu-text ${
                          isSidebarOpen ? "visible" : "hidden"
                        }`}
                        aria-hidden={!isSidebarOpen}
                      >
                        {item.name}
                      </span>
                      {item.icon?.startsWith("fa-") ? (
                        <i className={`fas ${item.icon} menu-icon`}></i>
                      ) : (
                        <img
                          src={item.icon}
                          alt={`${item.name} icon`}
                          className="menu-icon"
                        />
                      )}
                    </Link>

                    {item.submenu && isSidebarOpen && (
                      <span className="dropdown-indicator">▼</span>
                    )}
                  </div>

                  {/* Submenu */}
                  {item.submenu && dropdownOpen === index && isSidebarOpen && (
                    <ul className="submenu">
                      {item.submenu.map((subItem, subIndex) => (
                        <li key={subIndex}>
                          <Link to={subItem.link}>
                            {subItem.icon?.startsWith("fa-") ? (
                              <i
                                className={`fas ${subItem.icon} submenu-icon`}
                              ></i>
                            ) : (
                              <img
                                src={subItem.icon}
                                alt={`${subItem.name} icon`}
                                className="submenu-icon"
                              />
                            )}
                            <span className="menu-text">{subItem.name}</span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </>
      )}
    </>
  );
};

export default Navbar;
